import { render, staticRenderFns } from "./Campaign.vue?vue&type=template&id=51871ad5&lang=pug&"
import script from "./Campaign.vue?vue&type=script&lang=js&"
export * from "./Campaign.vue?vue&type=script&lang=js&"
import style0 from "./Campaign.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51871ad5')) {
      api.createRecord('51871ad5', component.options)
    } else {
      api.reload('51871ad5', component.options)
    }
    module.hot.accept("./Campaign.vue?vue&type=template&id=51871ad5&lang=pug&", function () {
      api.rerender('51871ad5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/campaigns/Campaign.vue"
export default component.exports